/* eslint-disable react/prop-types */
import { getHistoricosPermisos } from 'api/nominas/historicoPermisos';
import { getSubcategoriasDeIncapacidades } from 'api/catalogos/subcategoriasIncapacidades';
import { getCategoriasDeIncapacidades } from 'api/catalogos/categoriasIncapacidades';
import { getConfiguracionIncidencias } from 'api/nominas/incidencias/configuracionIncidencias';
import { checkToken } from 'api/utils';
import Table from 'components/Table';
import React, { useEffect, useState } from 'react';
import { formatReceived } from 'utils/formatValues';
import { getModelPermission } from 'utils/permission';

export const HistoricoIncapadidades = {
  permissionModel: 'historicopermiso',
  catalogsModels: [],
  tabsModels: [],
};

const ExpedienteIncapacidades = ({
  currentEmpleado,
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [incidencias, setIncidencias] = useState([]);
  const [categoriaIncapacidades, setCategoriaIncapacidades] = useState([]);
  const [subcategoriaIncapacidades, setSubcategoriaIncapacidades] = useState([]);

  const getPermission = getModelPermission(
    HistoricoIncapadidades.permissionModel,
    HistoricoIncapadidades.catalogsModels,
    HistoricoIncapadidades.tabsModels,
    false,
  );

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _incidencias,
        _categoriasIncapacidades,
        _subcategoriasIncapacidades,
        _data,
      ] = await Promise.all([
        getConfiguracionIncidencias(),
        getCategoriasDeIncapacidades(),
        getSubcategoriasDeIncapacidades(),
        getHistoricosPermisos({ empleado: currentEmpleado, es_una_incapacidad_medica: true }),
      ]);
      if (mounted) {
        setIncidencias(_incidencias);
        setCategoriaIncapacidades(_categoriasIncapacidades);
        setSubcategoriaIncapacidades(_subcategoriasIncapacidades);
        setData(formatReceived(_data));
        setLoading(false);
      }
    };
    if (currentEmpleado) {
      fetchAll();
    } else {
      setData([]);
      setLoading(false);
    }
    return () => { mounted = false; };
  }, [currentEmpleado]);

  const columns = [
    // { titleText: 'No. de Incapacidad', dataIndex: 'numero_incapacidad',
    //   key: 'numero_incapacidad', width: 250 },
    {
      titleText: 'Fecha Ejecución',
      dataIndex: 'fecha_de_ejecucion',
      key: 'fecha_de_ejecucion',
      width: 200,
      render: (val) => val?.format('DD/MM/YYYY'),
    },
    {
      titleText: 'Fecha Inicial',
      dataIndex: 'fecha_de_inicio',
      key: 'fecha_de_inicio',
      width: 200,
      render: (val) => val?.format('DD/MM/YYYY'),
    },
    {
      titleText: 'Fecha Final',
      dataIndex: 'fecha_de_fin',
      key: 'fecha_de_fin',
      width: 200,
      render: (val) => val?.format('DD/MM/YYYY'),
    },
    {
      titleText: 'Días de Incapacidad',
      dataIndex: 'dias_de_permiso',
      key: 'dias_de_permiso',
      width: 200,
    },
    {
      titleText: 'Incapacidad Referencia',
      dataIndex: 'incidencia',
      key: 'incidencia',
      width: 300,
      render: (val) => {
        const incidencia = incidencias.find((item) => item?.id === val);
        return incidencia ? `${incidencia?.clave} - ${incidencia.concepto}` : '';
      },
    },
    {
      titleText: 'Categoría',
      dataIndex: 'incidencia_categoria',
      key: 'incidencia_categoria',
      width: 300,
      render: (val) => {
        const catInc = categoriaIncapacidades.find((item) => item?.id === val);
        return catInc ? `${catInc?.clave} - ${catInc?.concepto}` : '';
      },
    },
    {
      titleText: 'Subcategoría',
      dataIndex: 'incidencia_subcategoria',
      key: 'incidencia_subcategoria',
      width: 300,
      render: (val) => {
        const subcatInc = subcategoriaIncapacidades.find((item) => item?.id === val);
        return subcatInc ? `${subcatInc?.clave} - ${subcatInc?.concepto}` : '';
      },
    },
  ];

  return (
    <Table
      cols={columns}
      data={data}
      permission={getPermission}
      loading={loading}
      allowExportPDF={false}
    />
  );
};

export default ExpedienteIncapacidades;
